var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { cx, css as emotionCss } from 'emotion';
import { Tab as Component, Target as XTarget, TargetActive as XTargetActive, TargetError, TargetActiveError, Emblem, EmblemActive, EmblemError, ErrorIcon, } from './Tabs.styled';
import { getAutomation, getDebug } from '@citrus/runtime';
import { useTheme } from '@citrus/user';
import { isNotNullOrEmpty } from '@pcty/utils';
export var tabsActiveIdentifier = 'citrus-active-tab-8790q';
var VERSION = '2.13.0';
// @private
// __active?: boolean;
// __index: number;
// __onClick?: (index: number) => void,
// __validate?: (index: number) => boolean,
// DO NOT REMOVE padding prop even though it is not used. It is used in the parent.
var Tab = React.forwardRef(function (_a, ref) {
    var _b;
    var automationId = _a.automationId, className = _a.className, css = _a.css, count = _a.count, error = _a.error, 
    // FIXME: check if `padding` is needed
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    padding = _a.padding, render = _a.render, _c = _a.text, text = _c === void 0 ? '' : _c, _d = _a.__active, __active = _d === void 0 ? false : _d, __index = _a.__index, _e = _a.__onClick, __onClick = _e === void 0 ? function () { return undefined; } : _e, _f = _a.__validate, __validate = _f === void 0 ? function () { return true; } : _f, _g = _a.__TYPE, __TYPE = _g === void 0 ? 'Tab' : _g, other = __rest(_a, ["automationId", "className", "css", "count", "error", "padding", "render", "text", "__active", "__index", "__onClick", "__validate", "__TYPE"]);
    var YTarget = error ? TargetError : XTarget;
    var TargetActive = error ? TargetActiveError : XTargetActive;
    var Target = __active ? TargetActive : YTarget;
    var citrus2022 = useTheme().citrus2022;
    var classes = cx((_b = {},
        _b[emotionCss(css)] = isNotNullOrEmpty(css),
        _b), className || '');
    if (!!render) {
        return (React.createElement(Component, __assign({ className: classes, ref: ref }, other, getAutomation(automationId), getDebug(sessionStorage.getItem('citrus-debug') === 'true', __TYPE, VERSION)),
            React.createElement("div", null, render())));
    }
    var renderCount = function () {
        var badgeProps = { 'data-automation-id': (automationId && "".concat(automationId, "-count")) || null };
        if (error) {
            return count ? React.createElement(EmblemError, __assign({}, badgeProps), count) : null;
        }
        if (__active) {
            return count ? React.createElement(EmblemActive, __assign({}, badgeProps), count) : null;
        }
        return count ? React.createElement(Emblem, __assign({}, badgeProps), count) : null;
    };
    return (React.createElement(Component, __assign({ className: classes, ref: ref }, other, getAutomation(automationId), getDebug(sessionStorage.getItem('citrus-debug') === 'true', __TYPE, VERSION)), citrus2022 ? (React.createElement(Target, __assign({ className: __active ? tabsActiveIdentifier : '', onClick: function () { return (__validate(__index) ? __onClick(__index) : null); } }, other),
        error ? React.createElement(ErrorIcon, null) : '',
        text,
        renderCount())) : (React.createElement(Target, __assign({ className: __active ? tabsActiveIdentifier : '', onClick: function () { return (__validate(__index) ? __onClick(__index) : null); } }, other),
        text,
        error ? React.createElement(ErrorIcon, null) : '',
        renderCount()))));
});
Tab.defaultProps = {
    __TYPE: 'Tab',
};
export default Tab;
